import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Modal, Button, Form, Row, Col, Spinner, InputGroup } from 'react-bootstrap';
import { useAuth } from '../lib/StAuthGiver.js';
import { callApi } from '../lib/Common_funcs.js';

const WhichEnv = (process.env.REACT_APP_TURBO_ENV === undefined ? 'aws' : 'staging');
const Tdebug = (WhichEnv != 'aws');

const updateSiteData = (newSiteId, newSiteName) => {
    const curSiteIdx = localStorage.getItem('curSiteIdx');
    let currentSites = JSON.parse(localStorage.getItem("sites"));
    const curSitesLen = currentSites.length;

    Tdebug && console.log(curSiteIdx);
    Tdebug && console.log(currentSites);

    // currentSites is an array of JSON {siteId, siteName}
    // The length will be incremented by one. (Note: Its index
    // will remain the length as it starts from 0).
    currentSites.push({
        siteId: newSiteId,
        siteName: newSiteName
    });

    localStorage.setItem('curSiteIdx', curSitesLen);
    localStorage.setItem('sites', JSON.stringify(currentSites));

    // Update the uDet!
    let new_uDet = JSON.parse(localStorage.getItem('uDet'));
    new_uDet.sites = currentSites;
    localStorage.setItem('uDet', JSON.stringify(new_uDet));
};

export const StSiteCreatorModal = ({ show, onHide, onSiteCreated }) => {
    const [loading, setLoading] = useState(false);
    const { loginAction, logOut } = useAuth();
    const [error, setError] = useState('');
    const [siteInfo, setSiteInfo] = useState({
        siteName: '',
    });

    const navigate = useNavigate();

    const handleChange = (e) => {
        setSiteInfo({ ...siteInfo, [e.target.name]: e.target.value });
    };

    const handleClose = () => {
        // Reset form when closing
        setSiteInfo({ siteName: '' });
        setError('');
        setLoading(false);
        onHide();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        addNewSite();
    };

    const addNewSite = () => {
        const fetchData = async () => {
            try {
                const rcJson = await callApi('/sites', 'PUT', {}, 
                    JSON.stringify({
                        siteName: siteInfo.siteName
                    }));
                
                Tdebug && console.log(rcJson);

                if (rcJson.disposition == 'logout') {
                    Tdebug && console.log("Now logging out");
                    logOut();
                    return;
                }

                if (rcJson.httpStatus != 200) {
                    if (rcJson.disposition == 'retry') {
                        Tdebug && console.log(rcJson.message);
                        setError('Something went wrong, please retry...');
                    }
                    else if (rcJson.disposition == 'abort') {
                        Tdebug && console.log(rcJson.message);
                        setError('Something went wrong.');
                    }
                    else if ((rcJson.disposition == 'change') || (rcJson.disposition == 'resource exists')) {
                        Tdebug && console.log(rcJson.message);
                        setError(rcJson.message);
                    }
                    else if (rcJson.disposition == 'empty') {
                        Tdebug && console.log(rcJson.message);
                        Tdebug && console.log(rcJson);
                        setError(rcJson.message);
                    }

                    setLoading(false);

                    // If the cookie has changed, update it.
                    if (rcJson.respBody && rcJson.respBody.etac) {
                        loginAction(null, rcJson.respBody.etac);
                    }
                }
                else {
                    // If the cookie has changed, update it.
                    if (rcJson.respBody && rcJson.respBody.etac) {
                        loginAction(null, rcJson.respBody.etac);
                    }
                    
                    Tdebug && console.log("Setting values");
                    const newSiteId = rcJson.respBody.siteId;
                    
                    updateSiteData(newSiteId, siteInfo.siteName);
                    
                    // Close modal and notify parent
                    handleClose();
                    
                    // Notify parent component that a site was created
                    if (onSiteCreated) {
                        onSiteCreated(newSiteId, siteInfo.siteName);
                    }

                    Tdebug && console.log("Navigating to: /" + newSiteId + "/home");
                    navigate('/' + newSiteId + '/home', { replace: true });
                }
            } catch (error) {
                console.error('Error creating site:', error);
                setError('An unexpected error occurred.');
                setLoading(false);
            }
        };

        setLoading(true);
        setError('');
        fetchData();
    };

    return (
        <Modal 
            show={show} 
            onHide={handleClose} 
            centered 
            className="dashboard-modal shadow-lg"
        >
            <Modal.Header className="dashboard-modal-header">
                <Modal.Title className="dashboard-modal-title">
                    <i className="bi bi-plus-circle me-2" style={{ color: '#3B82F6' }}></i>
                    Add New Site
                </Modal.Title>
            </Modal.Header>
            
            <Modal.Body className="dashboard-modal-body">
                {error && (
                    <div className="alert alert-danger dashboard-alert" role="alert">
                        <div className="dashboard-alert-text">{error}</div>
                    </div>
                )}
                
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="siteName" className="mb-4">
                        <Form.Label className="dashboard-label">Site Name</Form.Label>
                        <InputGroup className="dashboard-input-group">
                            <Form.Control 
                                type="text" 
                                name="siteName" 
                                value={siteInfo.siteName}
                                onChange={handleChange} 
                                required 
                                disabled={loading}
                                placeholder="Enter your site name"
                                className="dashboard-input"
                            />
                            <InputGroup.Text className="dashboard-input-addon">
                                {process.env.REACT_APP_HOST_DOMAIN}
                            </InputGroup.Text>
                        </InputGroup>
                        <div className="dashboard-alert-note mt-2">
                            Choose a unique name for your website. This will be your site's URL.
                        </div>
                    </Form.Group>
                </Form>
            </Modal.Body>
            
            <Modal.Footer className="dashboard-modal-footer d-flex justify-content-end">
                <Button 
                    variant="outline-secondary" 
                    onClick={handleClose} 
                    disabled={loading}
                    className="dashboard-button-outline me-3"
                >
                    Cancel
                </Button>
                <Button 
                    variant="primary" 
                    onClick={addNewSite}
                    disabled={loading || !siteInfo.siteName.trim()}
                    className="dashboard-button-primary"
                >
                    {loading ? (
                        <>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                            />
                            Creating...
                        </>
                    ) : (
                        <>
                            <i className="bi bi-check-circle me-2"></i>
                            Create Site
                        </>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default StSiteCreatorModal;          

